




















import { Component, Vue, Prop } from "vue-property-decorator";
import { USER_ME, UserMeData } from "@/graphql/query/user/me";

export interface Me {
  name: string;
  company: string;
  group: string;
  groupId: string;
  isGroupManager: boolean;
}

@Component({
  apollo: {
    me: {
      query: USER_ME,
      update(data: UserMeData): Me {
        const { me } = data;
        const { group, company } = me;

        return {
          name: me.name,
          company: company.name,
          group: group.name,
          groupId: group.id,
          isGroupManager: !!me.scopes.find(
            s =>
              s.resource === "Group" &&
              s.resourceId === group.id &&
              s.action === "management"
          )
        };
      }
    }
  }
})
export default class GlobalHeader extends Vue {
  @Prop({ type: String, required: false, default: "" }) name!: string;
  me: Me | null = null;

  get nav() {
    return [
      { to: { name: "home" }, name: "ホーム" },
      //{ to: { name: "alert-a" }, name: "アラート" },
      {
        to: {
          name: "group-activity",
          params: { groupId: this.me!.groupId }
        },
        name: "操作履歴"
      },
      { to: { name: "groups-list" }, name: "グループ管理" },
      { to: { name: "my-details" }, name: "マイページ" }
      //{ to: { name: "admin" }, name: "ご契約情報" }
    ];
  }
}
